// Template219: Osaka - Consejos útiles 2 (Tips2)
// Header, list of tips from data.tips, optional sticker.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template219 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const contentColor = textColor || "#444";

	const headerText = page?.texts?.[0]?.content;
	const infoBox = page?.texts?.[1]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const stickerImage = getImageSrc("sticker");
	const logoImage = getCanvasImageUrl("logo");
	const actualHeaderColor = headerBackgroundColor || "#1F4E3D";
	const tips = Array.isArray(page?.data?.tips)
		? page.data.tips
		: Array.isArray(page?.data?.data?.tips)
			? page.data.data.tips
			: [];
	const tipBorderColor = actualHeaderColor;

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: 1.5,
					position: "relative",
					marginTop: 2.5,
				}}
			>
				{tips.map((tip, idx) => (
					<Box
						key={idx}
						data-block-id={`text-${idx + 2}`}
						sx={{
							backgroundColor: "#fff",
							borderRadius: "12px",
							padding: "12px 14px",
							display: "flex",
							alignItems: "center",
							gap: 1.25,
							border: "2px solid #d1e6de",
						}}
					>
						<Box sx={{ fontSize: 18 }}>{tip.icono || "💡"}</Box>
						<Box sx={{ fontSize: 13, color: contentColor }}>
							{typeof tip.texto === "string" && tip.texto.includes("<") ? (
								<Box
									component="span"
									dangerouslySetInnerHTML={{ __html: tip.texto }}
								/>
							) : (
								<>{tip.texto}</>
							)}
						</Box>
					</Box>
				))}

				{stickerImage && (
					<Box
						component="img"
						src={stickerImage}
						alt=""
						sx={{
							width: isSmallScreen ? 80 : 100,
							position: "absolute",
							top: isSmallScreen ? 220 : 140,
							right: isSmallScreen ? -20 : -40,
						}}
					/>
				)}

				{infoBox && (
					<Box
						data-block-id="text-info"
						sx={{
							backgroundColor: "#dee7e3",
							border: `2px solid ${tipBorderColor}`,
							borderRadius: 12,
							padding: "12px 14px",
							fontSize: 12,
							marginTop: 1,
							position: "relative",
						}}
						dangerouslySetInnerHTML={{ __html: infoBox }}
					/>
				)}
			</Box>
		</Box>
	);
};

Template219.thumbnail = "/images/template-1.png";
export default Template219;
